<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><mdb-icon icon="book" /> ข้อมูลสมุดโทรศัพท์</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-12">
				<!-- <div class="d-flex flex-row mr-5"> -->
				<div class="row">
					<div class="align-self-center ml-3">เลือกการค้นหา</div>
					<div class="col-12 col-md-4 p-2">
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text" id="basic-addon">
									<mdb-icon far icon="edit" />
								</span>
							</div>
							<input type="text" class="form-control" v-model="searchTxt" aria-describedby="basic-addon" width="80%" />
						</div>
					</div>
					<div class="col-12 col-md-6 py-1">
						<button type="button" class="btn btn-search color_white font12" style="font-weight:400; margin-left:-8px" @click="Search()"><i class="fab fa-sistrix"></i> Search</button>
						<router-link to="Setuseradd">
							<button id="Setuseradd" type="button" class="btn btn-add color_white font12" style="font-weight:400;"><i class="fas fa-plus"></i> Add</button>
						</router-link>
						<!-- <button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-times"></i> Cancel</button> -->
					</div>
				</div>
			</div>
		</div>

		<div>
			<mdb-datatable :arrows="true" :data="data" striped bordered :searching="false" scrollY maxHeight="450px" />
		</div>

		<div class="mt-3">
			<div class="row"></div>
		</div>
		<div class="row justify-content-center mt-3"></div>
	</div>
</template>

<script>
	//import $ from 'jquery'
	// import {mdbDatatable} from 'mdbvue'
	import moment from 'moment'
	import {mapGetters, mapActions} from 'vuex'
	export default {
		name: 'Setupsender',
		components: {
			// mdbDatatable,
		},
		data() {
			return {
				loading: false,
				searchTxt: '',
				data: {
					columns: [
						{
							label: '#',
							field: 'id2',
							sort: true,
						},
						{
							label: 'ชื่อสมุดโทรศัพท์',
							field: 'book_name',
							sort: true,
						},
						{
							label: 'จำนวนหมายเลข',
							field: 'amount_phone',
							sort: true,
						},
						{
							label: 'แก้ไขล่าสุด',
							field: 'date_update',
							sort: true,
							format: (value) => {
								return moment(value).format('DD/MM/YYYY HH:mm:ss')
							},
						},
						{
							label: 'แก้ไขโดย',
							field: 'username',
							sort: true,
						},
					],
					rows: null,
				},
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			clickCallback: function(pageNum) {
				console.log(pageNum)
			},

			// Dataphone() {
			// 	let totaldataphone = this.dataphone.split(',')

			// 	console.log('dataphone', totaldataphone.length)
			// },
			async Search() {
				this.loading = false
				if (this.searchTxt == '') {
					await this.callApiMotherFucker({
						method: 'get',
						path: '/bookphone',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
				} else {
					await this.callApiMotherFucker({
						method: 'get',
						path: '/bookphone',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
						}
					})
					this.data.rows = this.data.rows.filter((val) => {
						if (val.book_name.search(this.searchTxt) >= 0 || val.amount_phone.toString().search(this.searchTxt) >= 0 || val.username.search(this.searchTxt) >= 0) {
							return true
						} else {
							return false
						}
					})
					this.loading = true
				}
			},
		},
		async mounted() {
			await this.callApiMotherFucker({
				method: 'get',
				path: '/bookphone',
				data: {},
			}).then((res) => {
				this.loading = true
				if (res.payload) {
					this.data.rows = this.$add_index(res.payload)
				}

				// let dataresult = []
				// console.log('payload', res.payload)
				// res.payload.forEach((element) => {
				// 	let data = {
				// 		amount_phone: element.amount_phone,
				// 		book_name: element.book_name,
				// 		date_create: element.date_create,
				// 		date_update: element.date_update,
				// 		id: element.id,
				// 		phone_number: element.phone_number,
				// 		// phone_number_qty: element.phone_number.split(',').length,
				// 		username: element.username,
				// 	}
				// 	dataresult.push(data)
				// })
				// console.log('dataresult', dataresult)
				// this.data.rows = this.$add_index(dataresult)
				// this.loading = true
			})
		},
	}
</script>
<style scoped>
	.fa-13 {
		font-size: 1em;
	}
	.field-icon {
		margin-left: 25px;
		margin-right: 10px;
		margin-top: 0px;
		position: relative;
		z-index: 2;
	}
</style>
<style>
	.label1 {
		color: red !important;
	}
</style>
